import { useEffect, useState } from "react";
import {
  Button,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
} from "@mui/material";
import { UseAdvContract } from "./UseAdvContract";
import { useNavigate, useLocation, Link } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import AdvertismentsAutoComplete from "../advertisments/AdvertismentsAutoComplete";
import AdvCustomerAutoComplete from "../adv-customers/AdvCustomerAutoComplete";
import { removeComma, toMoney } from "../../util/Utils";
import ItemsGrid from "./ItemsGrid";

export default function EditContract(props) {
  const { toSolar } = require("jdate-convert");
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const location = useLocation();
  const [advs, setAdvs] = useState();
  const { validate, updateAdvContract, getAdvContractByID } = UseAdvContract();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();
  const [valueStart, setValueStart] = useState();
  const [valueEnd, setValueEnd] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];

  const [state, setState] = useState({
    id: undefined,
    factorDate: undefined,
    customerID: undefined,
    cost: undefined,
    vat: undefined,
    totalCost: undefined,
    isSettle: false,
    discount: undefined,
    active: false,
    isOfficial: false,
    description: undefined,
  });

  const [errorState, setErrorState] = useState({
    customerID: false,
    totalCost: false,
    factorDate: false,
  });

  useEffect(() => {
    if (location.state && location.state.id) {
      getAdvContractByID(location.state.id, (advs) => {
        setState({
          id: advs.id,
          cost: advs.cost,
          discount: advs.discount,
          customerID: advs.customerID,
          factorDate: advs.factorDate?.split("T")[0],
          vat: advs.vat,
          totalCost: advs.totalCost,
          description: advs.description,
          isSettle: advs.isSettle,
          active: advs.active,
          isOfficial: advs.isOfficial,
        });
      });
    }
  }, [location.state]);

  useEffect(() => {
    let newValueStart = valueStart?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    setState({ ...state, factorDate: newValueStart });
  }, [valueStart]);

  return (
    <Detail
      breadChilds={{
        title: "تبلیغات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/advertismentcontract" },
          {
            name: "ویرایش قرارداد",
            url: "/advertismentcontract/editAdvertismentContract",
          },
        ],
      }}
    >
      {!advs ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 7"}>
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              onChange={setValueStart}
              value={state && state.factorDate ? toSolar(state.factorDate) : ""}
              render={
                <TextField
                  sx={{ pr: 2, input: { textAlign: "center" } }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label="تاریخ قرارداد"
                  error={errorState.factorDate}
                />
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 4"}>
            <AdvCustomerAutoComplete
              selectedCustomerID={state.customerID}
              errorState={errorState.customerID}
              state={state}
              setState={setState}
            />
          </Box>

          {!isSmall && <Box gridColumn="span 8"></Box>}
          <Box gridColumn="span 12">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 1,
              }}
            >
              <Typography color="secondary" sx={{ mb: 1 }} variant="subtitle1">
                آیتم ها :
              </Typography>

              <Link
                target="_blank"
                to={{
                  pathname: `/advertismentcontract/factorPrint?contractID=${state.id}`,
                }}
              >
                <Button color="secondary" variant="contained">
                  چاپ فاکتور
                </Button>
              </Link>
            </Box>
            <ItemsGrid
              callback={(contractID) => {
                getAdvContractByID(contractID, (advs) => {
                  setState({
                    id: advs.id,
                    cost: advs.cost,
                    discount: advs.discount,
                    customerID: advs.customerID,
                    factorDate: advs.factorDate?.split("T")[0],
                    vat: advs.vat,
                    totalCost: advs.totalCost,
                    description: advs.description,
                    isSettle: advs.isSettle,
                    active: advs.active,
                    isOfficial: advs.isOfficial,
                  });
                });
              }}
              contractId={state.id}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.cost ? toMoney(state.cost) : ""}
              label="مجموع"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                // let vatCost =
                //   (removeComma(evt.target.value) * window.ENV.taxValue) / 100;
                setState({
                  ...state,
                  cost: removeComma(evt.target.value),
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.vat ? toMoney(state.vat) : ""}
              label="مالیات بر ارزش افزوده"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  vat: removeComma(evt.target.value),
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.discount ? toMoney(state.discount) : ""}
              label="تخفیف"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({
                  ...state,
                  discount: removeComma(evt.target.value),
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.totalCost ? toMoney(state.totalCost) : ""}
              label="مبلغ قابل پرداخت"
              size="small"
              variant="outlined"
              error={errorState.totalCost}
              onChange={(evt) => {
                setState({
                  ...state,
                  totalCost: removeComma(evt.target.value),
                });
              }}
              sx={{
                input: {
                  textAlign: "right",
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}

          <Box gridColumn="span 12">
            <TextField
              fullWidth
              value={state.description ? state.description : ""}
              label="توضیحات"
              multiline
              rows={3}
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, description: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>

          <Box gridColumn={isSmall ? "span 12" : "span 7"}>
            <FormControlLabel
              checked={state.isOfficial ? state.isOfficial : false}
              onChange={(evt) => {
                setState({ ...state, isOfficial: evt.target.checked });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="فاکتور به صورت رسمی ارسال شود"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 7"}>
            <FormControlLabel
              checked={state.active ? state.active : false}
              onChange={(evt) => {
                setState({ ...state, active: evt.target.checked });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="فعال"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 7"}>
            <FormControlLabel
              checked={state.isSettle ? state.isSettle : false}
              onChange={(evt) => {
                setState({ ...state, isSettle: evt.target.checked });
              }}
              control={<Checkbox sx={{ py: 0 }} />}
              label="تسویه شد"
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}

          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  updateAdvContract(state, () => {
                    navigate("/advertismentcontract", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/advertismentcontract", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
